import {ApolloClient,ApolloLink,concat,HttpLink,InMemoryCache} from '@apollo/client';
import {WebSocketLink} from 'apollo-link-ws';
import { getMainDefinition } from 'apollo-utilities';
import {split} from 'apollo-link';

const authRequest=new ApolloLink((operation,forward) => {
    const token = localStorage.getItem('token');
    const refreshToken =localStorage.getItem('refreshToken');
    operation.setContext(({ headers = {} }) => ({
      headers: {
        ...headers,
        'x-token': token ? token : '',
        'x-refresh-token': refreshToken ? refreshToken :'',
      },
    }));
  
    return forward(operation).map(response=>{
      const context=operation.getContext();
      const token=context.response.headers.get('x-token');
      const refreshToken=context.response.headers.get('x-refresh-token')
      
      if(token && refreshToken){
        localStorage.setItem('token',token);
        localStorage.setItem('refreshToken',refreshToken);
      }
      return response;
    });
  });
  
  const httpLink = new HttpLink({ uri: 'https://play-in.herokuapp.com/graphql' });
  const httpLinkMiddleware=concat(authRequest,httpLink);
  const wsLink=new WebSocketLink({
    uri:'wss://play-in.herokuapp.com/subscriptions',
    options:{
        reconnect:true,
        connectionParams:{
            token:localStorage.getItem('token'),
            refreshToken:localStorage.getItem('refreshToken'),
        },
    }
  });

  const link=split(
      ({query})=>{
        const {kind,operation} = getMainDefinition(query);
        return kind === 'OperationDefinition' && operation==='subscription';
      },
      wsLink,
      httpLinkMiddleware
  );
  export default new ApolloClient({
    cache: new InMemoryCache(),
    link,
  });

 
  

